<template>
    <div class="wrapper bg-gray-200 antialiased text-gray-900 rounded-lg p-5 mb-12">
      <div>
        <img
           v-if="!property.photos[0].full_url"
          :src="property.photos[0] ? 'https://lapedrera.com.uy/img/inmuebles/' + property.ID + '_' +  property.photos[0].ID + '.jpg'  : 'https://www.lapedrera.com.uy/images/localidades/la-pedrera/00.jpg' " 
          alt=" random imgee"
          class="w-full object-cover object-center rounded-lg shadow-md"
        />

        <img
           v-if="property.photos[0].full_url"
          :src="property.photos[0].full_url" 
          alt=" random imgee"
          class="w-full object-cover object-center rounded-lg shadow-md"
        />




        <div class="relative px-4 -mt-16  ">
          <div class="bg-white p-6 rounded-lg shadow-lg">
            <div class="flex justify-between bg-gray-100 mt-1 p-1">
              <span
                class="bg-teal-200 text-teal-800 text-xs  inline-block rounded-full  uppercase font-semibold tracking-wide"
              >
                <ul>
                  <li v-for="loc in location" :key="loc.id">
                    <div v-if="loc.id == property.zona">
                      {{ loc.name }}
                    </div>
                  </li>
                </ul>
              </span>
              <div
                class="ml-2 text-gray-600 uppercase text-xs font-semibold tracking-wider"
              >
                <ul>
                  <li v-for="t in propertyType" :key="t.id">
                    <div v-if="t.id == property.tipo_inmueble">
                      {{ t.name }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <h4
              class="mt-1 text-xl  font-semibold uppercase leading-tight truncate"
            >
              {{ property.nombre }}
            </h4>
          
              

              <p class="mt-2 text-sm">
                <span  v-html="property.descripcion_corta" ></span>
              </p>

            <div class="mt-4">
              <div
                class="flex flex-row justify-left rounded-lg text-md mb-4"
                role="group"

              >
               <!-- <inertia-link class="flex items-center group py-3" :href="route('properties.basicEdit',  property.ID)" method="get" as="button">
        <div class="">editar</div>
      </inertia-link> -->
              <!-- <a :href="route('properties.basicEdit')">Editar</a> -->
                <inertia-link  :href="route('properties.basicEdit',  property.ID)" method="get" as="button"
                  class="bg-green-500 w-full  font-semibold block text-white text-base hover:bg-blue-400 rounded px-4 py-2 mx-0 outline-none focus:shadow-outline"
                >
                  Editar inmueble
                  <span v-if="property.operacion == 1">
                    
                    <small>(Calendario-Precio)</small>
                  </span>
                </inertia-link>
                  
                
                <!-- <inertia-link   v-if="property.operacion == 1" :href="route('properties.basicEdit',  property.ID)" method="get" as="button"
                  class="bg-orange-500 text-white hover:bg-blue-400  px-4 py-2 mx-0 outline-none focus:shadow-outline"
                >
                  Calendario
               </inertia-link>
  
                <inertia-link  :href="route('properties.basicEdit',  property.ID)" method="get" as="button"  v-if="property.operacion == 1"
                  class="bg-orange-600 text-white hover:bg-blue-400 rounded-r-lg px-4 py-2 mx-0 outline-none focus:shadow-outline"
                >
                  Precios
               </inertia-link> -->
              </div>

         
               <div v-if="property.operacion == 1">
                <div  class="  absolute top-1 -right-1 text-sm	 bg-indigo-500  py-0 px-2 text-white text-center font rounded" >Alquiler</div>
              </div>
              <div v-if="property.operacion == 2">
                <div  class=" absolute top-1 -right-1 text-sm	  bg-green-500   py-0 px-2 text-white text-center font rounded" >Venta</div>

              </div>
              <div v-if="property.operacion == 3">
                <div  class=" absolute top-1 -right-1 text-sm	  bg-yellow-500  py-0 px-2 text-white text-center font rounded" style="width: ;" >Transitorio</div>

              </div>
              <div class="mt-4">
                <p class="flex items-center text-black text-sm font-medium">
                  <img
                    src="/header-logo.png"
                    alt=""
                    class="w-6 h-6 rounded-full mr-2 bg-gray-100"
                  />
                  Propiedad de {{ $page.props.auth.user.first_name }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Icon from '@/Shared/Icon'
export default {
  components: {
    Icon,
  },
  props: {
    property: Object,
    propertyType: Array,
    location: Array,
  },
};
</script>
